import { mergeOverrides } from 'baseui';
import { Card as BaseCard, StyledTitle } from 'baseui/card';
import type { CardProps as BaseCardProps, CardOverrides } from 'baseui/card';
import tailwindDefaultTheme from 'tailwindcss/defaultTheme';

import { withStyle } from 'theme';

type OwnProps = {
  overrides?: CardOverrides;
};

export const CardTitle = withStyle(StyledTitle, {
  fontSize: tailwindDefaultTheme.fontSize.xl[0],
  lineHeight: `${tailwindDefaultTheme.fontSize.xl[1]}`,
  fontWeight: `${tailwindDefaultTheme.fontWeight.semibold}`,
});

const cardOverrides: CardOverrides = {
  Root: {
    style: {
      paddingTop: '1.5rem',
      paddingRight: '1.5rem',
      paddingBottom: '1.5rem',
      paddingLeft: '1.5rem',
    },
  },
  Body: {
    style: {
      marginTop: '0',
      marginRight: '0',
      marginBottom: '0',
      marginLeft: '0',
    },
  },
  Contents: {
    style: {
      marginTop: '0',
      marginRight: '0',
      marginBottom: '0',
      marginLeft: '0',
    },
  },
  Title: {
    component: CardTitle,
  },
};

export default function Card(
  props: Omit<BaseCardProps, keyof OwnProps> & OwnProps,
) {
  return (
    <BaseCard
      {...props}
      overrides={mergeOverrides(cardOverrides, props.overrides)}
    />
  );
}
